export default {
  title: 'Notifications',
  loading: 'Loading...',
  noNotifications: 'No notifications',
  loadMore: 'Load more notifications',
  serviceCategoryApprovalError: 'Error approving service category',
  serviceCategoryApproved:
    'The service category has been approved and is now visible to all users.',
  button: {
    manageAlliances: 'Manage my alliances',
    view: 'View',
    manageWallet: 'Manage my wallet',
    viewDetails: 'View details',
    viewProspects: 'View my contacts',
    viewJobs: 'View my job offers',
    viewSubmissions: 'View submissions',
    viewProjects: 'View my projects',
    viewAdjustment: 'View adjustment',
    viewProject: 'View project',
    viewJob: 'View job',
    viewSubmission: 'View submission',
    viewQuoteRequest: 'View quote request',
    viewHub: 'View details',
    approveAndMakeVisibleForAll: 'Approve and make available to everyone',
  },
  message: {
    alliance_accepted: '{{name}} has accepted your alliance request',
    alliance_rejected: '{{name}} has declined your alliance request',
    alliance_created: '{{name}} sent you an alliance request',
    alliance_re_requested: '{{name}} has resent you an alliance request',
    alliance_retired: '{{name}} has ended an alliance',
    job_cancelled: '{{name}} has cancelled his offer',
    adjustment_submitted: '{{name}} has submitted an adjustment for your quote',
    quote_alliance_invited: '{{name}} has invited you to participate in their quote',
    quote_alliance_accepted: '{{name}} has accepted your invitation to participate in their quote',
    quote_alliance_rejected: '{{name}} has declined your invitation to participate in their quote',
    quote_alliance_retired: '{{name}} has removed you from their quote',
    quote_alliance_retired_by_alliance: '{{name}} has remove his quote',
    new_job_posted: '{{name}} has posted an offer that might interest you',
    quote_request_received: '{{name}} has sent you a quote request',
    quote_request_accepted: '{{name}} has accepted your quote request',
    quote_request_rejected: '{{name}} has declined your quote request',
    quote_submitted: '{{name}} has submitted a quote for your job',
    child_quote_submitted: '{{name}} has submitted their part of the collaborative quote',
    parent_quote_submitted: '{{name}} has submitted the parent quote for your collaboration',
    quote_change_requested: '{{name}} has requested changes to your quote',
    quote_accepted: '{{name}} has accepted your quote',
    parent_quote_accepted: '{{name}} has accepted your quote through collaboration',
    quote_rejected: '{{name}} has rejected your quote',
    parent_quote_rejected: '{{name}} has rejected your quote through collaboration',
    quote_not_accepted: '{{name}} has not retained your quote',
    parent_quote_not_accepted: '{{name}} has not retained your quote through collaboration',
    project_status_updated: '{{name}} has updated your project status',
    new_contact_added: '{{name}} is now one of your contacts',
    project_completed: '{{name}}has marked your project {{project}} as completed',
    project_cancelled: '{{name}} has cancelled your project {{project}}',
    new_report_submitted: '{{name}} has submitted a new report',
    new_industry_suggested: '{{name}} has suggested a new industry',
    new_service_category_suggested: '{{name}} has suggested a new service',
    job_expiring_soon: 'Your project "{{jobTitle}}" will expire soon — renew it for free',
    job_expired:
      'Your project "{{jobTitle}}" is no longer accepting new offers — renew it for free',
    job_expired_hasApplicants:
      'Your project "{{jobTitle}}" is no longer accepting new offers — renew it for free, or switch its status to "Reviewing quotes" to notify freelancers who submitted an offer.',
    job_removal_warning:
      'Your project "{{jobTitle}}" will soon be removed from the job board — renew it for free',
    job_removed: 'Your project "{{jobTitle}}" has been removed from the job board',
    job_expired_for_applicant:
      'The project "{{jobTitle}}" is no longer accepting new offers. You didn\'t get a chance to finish your submission.',
    job_renewed_for_applicant: 'The project "{{jobTitle}}" is active again and accepting offers',
    job_selection_period_started:
      'Your project "{{jobTitle}}" is now in its quote review period — freelancers who submitted an offer have been notified.',
    job_selection_period_started_for_applicant:
      'The recruiter for "{{jobTitle}}" has started reviewing submitted quotes. Expect an answer soon.',
    hub_message: '{{name}} sent you a message',
    hub_message_attachment: '{{name}} shared a document with you',
    credits_gifted_manual: '{{name}} has added {{amount}} credits to your account',
    credits_gifted_monthly: 'Your monthly {{amount}} credits have been added to your account',
    job_edited_by_admin: 'An administrator updated your project "{{jobTitle}}"',
    job_unpublished_by_admin: 'An administrator unpublished your project "{{jobTitle}}"',
    job_paused_by_admin: 'An administrator paused your project "{{jobTitle}}"',
    job_assigned_by_admin: 'An administrator assigned you the project "{{jobTitle}}"',
    welcome: 'Welcome to Nous Pigeons!',
    fallback: 'You have a new notification',
  },
  first_name_fallback: 'Someone',
  alliance_rejected_modal: {
    title: '{{name}} has declined your alliance request',
    subTitle: 'Message from <bold>{{name}}</bold>',
  },
  quote_rejected_modal: {
    title: '{{name}} has rejected your quote',
    subTitle: 'Reason for rejection',
    default_message:
      'Your quote has been rejected because the job is either cancelled or the job owner has accepted another quote.',
  },
  quote_request_rejected_modal: {
    title: '{{name}} has declined your quote request',
    subTitle: 'Message from <bold>{{name}}</bold>',
  },
  quote_alliance_rejected_modal: {
    title: '{{name}} has declined your invitation to participate in their quote',
    subTitle: 'Message from <bold>{{name}}</bold>',
  },
  job_moderated_by_admin_modal: {
    subTitle: 'Reason from the administrator',
  },
  new_service_category_suggested_modal: {
    title: '{{name}} has suggested a new service category',
    subTitle: 'The new service category:',
  },
  new_industry_suggested_modal: {
    title: '{{name}} has suggested a new business industry',
    subTitle: 'The new business industry:',
  },
  new_report_submitted_modal: {
    title: '{{name}} has submitted a new report',
    subTitle: 'The new report:',
  },
  adjustment_submitted_modal: {
    title: '{{name}} has submitted an adjustment',
    subTitle: 'following your request:',
  },
  ViewAllNotifications: 'View all my notifications',
  industryApprovalError: 'Error approving industry',
  industryApproved: 'The industry has been approved and is now visible to all users.',
  quote_request_change_modal: {
    title: '{{name}} sent you an adjustment request',
    subTitle: 'Message from <bold>{{name}}</bold>',
  },
  close: 'Close',
} as const;
